import { graphql } from "@/lib/gql/__generated__";

/**
 * キャンセルで変わるフィールドを返す。
 * 入れ子のオブジェクト（aliveItems* / deadItems）はキャッシュ更新時に丸ごと置き換わるため、
 * 予約詳細クエリ（RESERVATION_DETAIL_FOR_MANAGEMENT_RESERVATION_ITEM_QUERY）と同じ選択にしておくこと。
 */
export const RESERVATION_DETAIL_CANCEL_FOR_MANAGEMENT_RESERVATION_ITEM_DETAIL_UPDATE_MUTATION = graphql(/* GraphQL */ `
	mutation ReservationDetailCancelForManagementReservationItemDetailUpdate($input: ReservationCancelInput!) {
		reservationDetailCancel(input: $input) {
			reservationDetail {
				updatedAt
				statusRequest
				statusReservation
				statusPayment
				canCancel
				willCancelPrice
				canUpdate
				canRefund
				canIssueReceipt
				canChargeCancelFee
				willCancelFeeChargePrice
				canHandleLocalPaymentCancelFee
				localCancelFeeTransferAccountName
				localCancelFeeTransferDate
				totalGuestCharge
				aliveItemsPerReservation {
					plan {
						name
						price
						hostInsertedPrice
						discountedPrice
					}
					options {
						name
						amount
						price
						hostInsertedPrice
						discountedPrice
					}
					additionalFees {
						name
						billingTypeTerm
						billingTypeTarget
						unitPrice
						totalPrice
						hostInsertedPrice
						totalDiscountedPrice
					}
					discount {
						name
						discountPrice
					}
					vouchers {
						name
						voucherPrice
					}
				}
				aliveItemsPerDate {
					date
					rooms {
						name
						roomNum {
							adultNum
							kidsNum {
								age
								asCosleeping
							}
							uniqueRoomID
						}
						price
						hostInsertedPrice
						discountedPrice
					}
					options {
						name
						amount
						price
						hostInsertedPrice
						discountedPrice
					}
				}
				deadItems {
					plan {
						name
						canceledPrice
					}
					rooms {
						name
						date
						roomNum {
							adultNum
							kidsNum {
								age
								asCosleeping
							}
							uniqueRoomID
						}
						canceledPrice
					}
					options {
						name
						dates
						amount
						canceledPrice
					}
					additionalFees {
						name
						billingTypeTerm
						billingTypeTarget
						canceledPrice
					}
				}
			}
			userErrors
		}
	}
`);
